import { restClient } from 'config/store/configureStore';

import { USER_GUIDES_CAMPUS_URL } from 'constants/ApiConstants';

export default {
  getFleetbackUserGuideLink: params => restClient.get(USER_GUIDES_CAMPUS_URL, { params }),
};
